import { LucideIcon, XCircle } from 'lucide-react'
import { FC, ReactNode } from 'react'

import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface ErrorCardProps {
  title: ReactNode
  description?: ReactNode
  className?: string
  icon?: LucideIcon
}

const ErrorCard: FC<ErrorCardProps> = ({ title, description, className, icon: Icon = XCircle }) => {
  return (
    <Card className={cn(className, 'max-w-sm w-full text-center shadow-sm p-0')}>
      <CardHeader className="flex flex-col items-center p-4 pt-6">
        <div className="flex items-center justify-center p-4 bg-muted rounded-2xl aspect-square">
          <Icon className="w-10 h-10 text-rose-700" />
        </div>
        <CardTitle className="pt-2 text-lg">{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
    </Card>
  )
}

export default ErrorCard
